/* AHIHQ Motors theme — one file, runs per page by what's on it. */
(() => {
  "use strict";
  const A = window.AHM || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmt = n => Number(n).toLocaleString("en-KE");
  const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const slug = s => String(s || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const waLink = t => `https://wa.me/${A.wa || ""}?text=${encodeURIComponent(t)}`;
  const SPECIAL = /tractor|motorbike|jet ski|bus|truck|boat/i;
  const isSpecial = c => SPECIAL.test(c.body || "");
  const nameOf = c => [c.year, c.make, c.model].filter(Boolean).join(" ");

  /* ---------- saved cars (per browser) ---------- */
  let SAVED = new Set();
  try { SAVED = new Set(JSON.parse(localStorage.getItem("ahm-saved") || "[]")); } catch (e) {}
  const persist = () => { try { localStorage.setItem("ahm-saved", JSON.stringify([...SAVED])); } catch (e) {} };
  function paintSaved() {
    $$("[data-savedn]").forEach(e => { e.textContent = SAVED.size; e.hidden = !SAVED.size; });
    $$("[data-heart]").forEach(h => {
      const on = SAVED.has(h.dataset.heart);
      h.setAttribute("aria-pressed", on);
      const lbl = h.querySelector("span"); if (h.hasAttribute("data-save-btn") && lbl) lbl.textContent = on ? "Saved" : "Save";
    });
  }
  let tt;
  function toast(msg) { const e = $("#toast"); if (!e) return; e.textContent = msg; e.hidden = false; clearTimeout(tt); tt = setTimeout(() => (e.hidden = true), 1900); }
  document.addEventListener("click", e => {
    const h = e.target.closest("[data-heart]"); if (!h) return;
    e.preventDefault();
    const r = h.dataset.heart; SAVED.has(r) ? SAVED.delete(r) : SAVED.add(r); persist(); paintSaved();
    toast(SAVED.has(r) ? "Saved. Find it under Saved cars" : "Removed from saved");
    document.dispatchEvent(new CustomEvent("ahm:saved"));
  });

  /* ---------- menu ---------- */
  const mnav = $("#mnav");
  const closeMenu = () => { if (!mnav) return; mnav.hidden = true; document.body.style.overflow = ""; $("#burger")?.setAttribute("aria-expanded", "false"); };
  $("#burger")?.addEventListener("click", () => { mnav.hidden = false; document.body.style.overflow = "hidden"; $("#burger").setAttribute("aria-expanded", "true"); $("#mclose")?.focus(); });
  $("#mclose")?.addEventListener("click", closeMenu);
  $$("[data-close-menu]").forEach(a => a.addEventListener("click", closeMenu));
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeMenu(); });

  /* ---------- stock feed ---------- */
  const feeds = {};
  function loadFeed(url) {
    url = url || A.feed;
    if (feeds[url]) return feeds[url];
    const key = "ahm-feed:" + url;
    try {
      const c = JSON.parse(sessionStorage.getItem(key) || "null");
      if (c && Date.now() - c.t < 10 * 60 * 1000) return (feeds[url] = Promise.resolve(prep(c.cars)));
    } catch (e) {}
    const get = p => fetch(url + (url.includes("?") ? "&" : "?") + "page=" + p, { credentials: "same-origin" }).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
    feeds[url] = get(1).then(first => {
      const rest = [];
      for (let p = 2; p <= (first.pages || 1); p++) rest.push(get(p));
      return Promise.all(rest).then(more => {
        const cars = first.cars.concat(...more.map(m => m.cars));
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), cars })); } catch (e) {}
        return prep(cars);
      });
    });
    return feeds[url];
  }
  function prep(cars) {
    cars.forEach(c => {
      c.ref = String(c.ref || "");
      c._s = [c.ref, c.make, c.model, c.year, c.body, c.fuel, c.trans, c.drive, c.loc, c.colour, c.engine, c.status === "way" ? "arriving on the way" : "here now in stock"].join(" ").toLowerCase();
    });
    return cars;
  }

  /* ---------- needs (lists come from theme settings) ---------- */
  const LISTS = {};
  Object.entries(A.needs || {}).forEach(([k, arr]) => { LISTS[k] = new Set((arr || []).map(s => s.trim().toLowerCase()).filter(Boolean)); });
  const onList = (k, c) => !!LISTS[k] && LISTS[k].has(`${c.make} ${c.model}`.toLowerCase());
  const NEED = {
    family: c => onList("family", c),
    upcountry: c => onList("upcountry", c) && c.drive === "4WD",
    hailing: c => onList("hailing", c),
    exec: c => onList("exec", c),
    low: c => c.km != null && c.km < 50000 && !isSpecial(c),
  };
  function needCounts(cars) {
    $$("[data-need]").forEach(el => {
      const f = NEED[el.dataset.need]; const n = f ? cars.filter(f).length : 0;
      const s = el.querySelector("[data-need-n]"); if (s) s.textContent = `${fmt(n)} ${n === 1 ? "car" : "cars"}`;
    });
  }

  /* ---------- card (keep in step with snippets/car-card.liquid) ---------- */
  function card(c) {
    const el = document.createElement("article"); el.className = "vc"; el.dataset.ref = c.ref;
    const name = nameOf(c);
    const spec = [c.km != null ? `<b>${fmt(c.km)} km</b>` : "Mileage on request", c.trans, c.fuel, c.engine, c.drive].filter(Boolean).map((s, i) => (i ? esc(s) : s)).join(" · ");
    const state = c.status === "way"
      ? `<div class="state way"><b>Arriving</b> · on the way to Mombasa</div>`
      : `<div class="state"><b>Here now</b>${c.loc ? ` · ${esc(c.loc)} showroom` : ""}</div>`;
    el.innerHTML = `<a class="ph" href="${esc(c.url)}" tabindex="-1" aria-hidden="true">${c.img ? `<img src="${esc(c.img)}" alt="" loading="lazy">` : `<span class="noimg">Photos coming</span>`}${c.n > 1 ? `<span class="pics"><svg aria-hidden="true"><use href="#i-cam"/></svg>${c.n} photos</span>` : ""}</a>
      <div class="bd">${state}<h3><span class="mk">${esc(c.make)}</span><a href="${esc(c.url)}">${esc(c.model || c.t)}</a><span class="yr">${esc(c.year || "")}</span></h3><p class="spec">${spec}</p></div>
      <div class="ft"><div class="pr">Ref ${esc(c.ref)}<b>Price on request</b></div><a class="btn btn-red" target="_blank" rel="noopener" href="${esc(waLink(`Hello AHIHQ Motors, I'm interested in the ${name} (Ref ${c.ref}). Is it still available?`))}"><svg aria-hidden="true"><use href="#i-wa"/></svg>Ask on WhatsApp</a></div>
      <button class="heart" type="button" data-heart="${esc(c.ref)}" aria-pressed="${SAVED.has(c.ref)}" aria-label="Save ${esc(name)}"><svg aria-hidden="true" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg></button>`;
    return el;
  }
  const fill = (box, cars) => { if (!box) return; box.innerHTML = ""; cars.forEach(c => box.append(card(c))); };
  const tally = (cars, k) => { const m = new Map(); cars.forEach(c => c[k] && m.set(c[k], (m.get(c[k]) || 0) + 1)); return [...m].sort((a, b) => b[1] - a[1]); };
  const opt = (sel, pairs) => { if (!sel) return; pairs.forEach(([v, t]) => { const o = document.createElement("option"); o.value = v; o.textContent = t; sel.append(o); }); };
  const qWords = q => {
    q = q.toLowerCase(); let max = null;
    const m = q.match(/(under|below|less than)\s+([\d,.]+)\s*(k)?\s*(km)?/);
    if (m) { max = parseFloat(m[2].replace(/,/g, "")) * (m[3] ? 1000 : 1); q = q.replace(m[0], " "); }
    return { words: q.split(/\s+/).filter(Boolean), max };
  };
  const matchQ = (c, q) => { const { words, max } = qWords(q); if (max && (c.km == null || c.km > max)) return false; return words.every(w => c._s.includes(w)); };

  /* ================= HOME ================= */
  if ($("#finder")) {
    loadFeed().then(cars => {
      const inN = cars.filter(c => c.status === "in").length, wayN = cars.filter(c => c.status === "way").length;
      $$('[data-stat="in"]').forEach(e => (e.textContent = fmt(inN)));
      $$('[data-stat="way"]').forEach(e => (e.textContent = fmt(wayN)));
      $$('[data-stat-wrap="way"]').forEach(e => (e.hidden = !wayN));
      $$('[data-stat="makes"]').forEach(e => (e.textContent = new Set(cars.map(c => c.make)).size));
      needCounts(cars);
      $$("[data-body-tile]").forEach(t => { const n = cars.filter(c => (c.body || "").toUpperCase() === t.dataset.bodyTile).length; t.querySelector("[data-n]").textContent = `${fmt(n)} cars`; if (!n) t.hidden = true; });
      $$("[data-loc-n]").forEach(s => { const n = cars.filter(c => c.status === "in" && c.loc === s.dataset.locN).length; s.textContent = `${fmt(n)} cars to view`; });
      const wt = $("[data-way-tile]");
      if (wt && wayN) { wt.href = A.all + "?status=way"; $("[data-way-title]").textContent = "Arriving"; $("[data-way-sub]").textContent = `${fmt(wayN)} on the way from Japan`; }
      // latest: newest in, one per model, no specialist vehicles
      const seen = new Set(), latest = [];
      cars.filter(c => c.status === "in" && c.img && !isSpecial(c))
        .sort((a, b) => (b.seen || "").localeCompare(a.seen || "") || b.year - a.year || (a.km ?? 1e9) - (b.km ?? 1e9))
        .forEach(c => { const k = c.make + c.model; if (latest.length < 8 && !seen.has(k)) { seen.add(k); latest.push(c); } });
      fill($("#latest"), latest);
      const mk = $("#makes");
      if (mk) tally(cars, "make").slice(0, 14).forEach(([m, n]) => { const a = document.createElement("a"); a.href = "/collections/" + slug(m); a.innerHTML = `<span>${esc(m)}</span><small>${n}</small>`; mk.append(a); });
      opt($("#h-make"), tally(cars, "make").map(x => x[0]).sort().map(m => [m, m]));
      opt($("#h-body"), tally(cars, "body").filter(([b]) => !SPECIAL.test(b)).slice(0, 10).map(([b]) => [b, b]));
      opt($("#h-year"), [...new Set(cars.map(c => c.year).filter(Boolean))].sort((a, b) => b - a).map(y => [y, `${y} or newer`]));
      const live = () => {
        const q = $("#h-q").value.trim(), mkv = $("#h-make").value, bd = $("#h-body").value, lc = $("#h-loc").value, y = $("#h-year").value;
        const n = cars.filter(c => (!mkv || c.make === mkv) && (!bd || c.body === bd) && (!lc || c.loc === lc) && (!y || c.year >= +y) && (!q || matchQ(c, q))).length;
        $("#h-go").textContent = `Show ${fmt(n)} ${n === 1 ? "car" : "cars"}`;
      };
      ["#h-q", "#h-make", "#h-body", "#h-loc", "#h-year"].forEach(id => $(id)?.addEventListener("input", live));
      live();
    }).catch(() => { const l = $("#latest"); if (l) l.innerHTML = '<div class="empty">Stock couldn\'t load. Refresh the page to try again.</div>'; });
    // drop empty fields so the stock-list URL stays clean
    $("#finder").addEventListener("submit", e => { $$("#finder [name]").forEach(i => { if (!i.value) i.disabled = true; }); setTimeout(() => $$("#finder [name]").forEach(i => (i.disabled = false)), 0); });
  }

  /* ================= STOCK LIST (collections + saved) ================= */
  const stock = $("[data-stock]");
  if (stock) {
    const savedMode = stock.dataset.saved === "true";
    const PAGE = 24;
    const SETS = ["loc", "body", "fuel", "trans", "drive"];
    const blank = () => ({ q: "", need: "", status: "", make: "", model: "", ymin: "", ymax: "", km: "", loc: new Set(), body: new Set(), fuel: new Set(), trans: new Set(), drive: new Set(), sort: "best" });
    const st = blank();
    let CARS = [], shown = PAGE;
    // read state from the URL (?make=Toyota&body=SUV,Van&need=family …)
    const P = new URLSearchParams(location.search);
    ["q", "need", "status", "make", "model", "ymin", "ymax", "km", "sort"].forEach(k => { if (P.get(k)) st[k] = P.get(k); });
    if (P.get("avail")) st.status = P.get("avail");
    SETS.forEach(k => (P.get(k) || "").split(",").filter(Boolean).forEach(v => st[k].add(v)));
    const focusSearch = P.get("focus") === "search";
    function writeURL() {
      const u = new URLSearchParams();
      ["q", "need", "status", "make", "model", "ymin", "ymax", "km"].forEach(k => st[k] && u.set(k, st[k]));
      SETS.forEach(k => st[k].size && u.set(k, [...st[k]].join(",")));
      if (st.sort !== "best") u.set("sort", st.sort);
      const s = u.toString(); history.replaceState(null, "", location.pathname + (s ? "?" + s : ""));
    }
    function checks(id, key, values) {
      const box = $(id); if (!box) return; box.innerHTML = "";
      box.closest(".fg").hidden = values.length < 2 && !st[key].size;
      values.forEach(([v, n]) => {
        const l = document.createElement("label"), i = document.createElement("input");
        i.type = "checkbox"; i.value = v; i.id = `${key}-${slug(v)}`; i.checked = st[key].has(v);
        i.addEventListener("change", () => { i.checked ? st[key].add(v) : st[key].delete(v); update(); });
        const t = document.createElement("span"); t.textContent = v; const s = document.createElement("small"); s.textContent = n;
        l.append(i, t, s); box.append(l);
      });
    }
    function fillModels() {
      const sel = $("#f-model"); const keep = st.model; sel.innerHTML = '<option value="">All models</option>'; sel.disabled = !st.make;
      if (st.make) opt(sel, [...new Set(CARS.filter(c => c.make === st.make).map(c => c.model))].sort().map(m => [m, m]));
      sel.value = keep;
    }
    function syncControls() {
      $("#q").value = st.q;
      $$("#f-avail button").forEach(b => b.setAttribute("aria-pressed", b.dataset.v === st.status));
      $("#f-make").value = st.make; fillModels();
      $("#f-ymin").value = st.ymin; $("#f-ymax").value = st.ymax; $("#f-km").value = st.km; $("#sort").value = st.sort;
      SETS.forEach(k => $$(`#f-${k} input`).forEach(i => (i.checked = st[k].has(i.value))));
      $$("[data-need]").forEach(b => b.setAttribute("aria-pressed", b.dataset.need === st.need));
    }
    function matches(c) {
      if (savedMode && !SAVED.has(c.ref)) return false;
      if (st.need && NEED[st.need] && !NEED[st.need](c)) return false;
      if (st.status && c.status !== st.status) return false;
      if (st.make && c.make !== st.make) return false;
      if (st.model && c.model !== st.model) return false;
      if (st.ymin && c.year < +st.ymin) return false;
      if (st.ymax && c.year > +st.ymax) return false;
      if (st.km && (c.km == null || c.km > +st.km)) return false;
      for (const k of SETS) if (st[k].size && !st[k].has(c[k])) return false;
      if (st.q && !matchQ(c, st.q)) return false;
      return true;
    }
    const SORTS = {
      best: (a, b) => (a.status === b.status ? 0 : a.status === "in" ? -1 : 1) || (!a.img - !b.img) || (isSpecial(a) - isSpecial(b)) || b.year - a.year || (a.km ?? 1e9) - (b.km ?? 1e9),
      new: (a, b) => (b.seen || "").localeCompare(a.seen || "") || b.year - a.year,
      ydesc: (a, b) => b.year - a.year, yasc: (a, b) => a.year - b.year,
      kasc: (a, b) => (a.km ?? 1e9) - (b.km ?? 1e9), kdesc: (a, b) => (b.km ?? -1) - (a.km ?? -1),
      make: (a, b) => (a.make + a.model).localeCompare(b.make + b.model),
    };
    const NEEDNAME = { family: "Family & school run", upcountry: "Upcountry roads", hailing: "Uber & Bolt", exec: "Executive", low: "Low mileage" };
    function pills() {
      const box = $("#active"); box.innerHTML = "";
      const add = (t, fn) => { const b = document.createElement("button"); b.type = "button"; b.textContent = t; b.setAttribute("aria-label", "Remove filter " + t); b.addEventListener("click", () => { fn(); syncControls(); update(); }); box.append(b); };
      if (st.q) add(`“${st.q}”`, () => (st.q = ""));
      if (st.need) add(NEEDNAME[st.need] || st.need, () => (st.need = ""));
      if (st.status) add(st.status === "in" ? "Here now" : "Arriving", () => (st.status = ""));
      if (st.make) add(st.make, () => { st.make = ""; st.model = ""; });
      if (st.model) add(st.model, () => (st.model = ""));
      if (st.ymin || st.ymax) add(`${st.ymin || "Any"}–${st.ymax || "now"}`, () => { st.ymin = ""; st.ymax = ""; });
      if (st.km) add(`Under ${fmt(st.km)} km`, () => (st.km = ""));
      SETS.forEach(k => st[k].forEach(v => add(v, () => st[k].delete(v))));
    }
    function update(keep) {
      if (!keep) shown = PAGE;
      writeURL();
      const list = CARS.filter(matches).sort(SORTS[st.sort] || SORTS.best);
      $("#count").textContent = fmt(list.length);
      $("#f-apply").textContent = `Show ${fmt(list.length)} ${list.length === 1 ? "car" : "cars"}`;
      const g = $("#grid"); g.innerHTML = "";
      const ask = () => { const t = $("#ask-tpl"); return t ? t.content.firstElementChild.cloneNode(true) : document.createElement("div"); };
      if (!list.length) {
        const e = document.createElement("div"); e.className = "empty";
        if (savedMode && !SAVED.size) e.innerHTML = `You haven't saved any cars yet. Tap the heart on any car to keep it here.<br><br><a class="btn btn-red" href="${esc(A.all)}">Browse stock</a>`;
        else e.innerHTML = `No cars match all of that. Remove a filter, or <a href="${esc(A.request)}">ask us to find it</a>.`;
        g.append(e); if (!savedMode) g.append(ask());
      }
      list.slice(0, shown).forEach((c, i) => { g.append(card(c)); if (!savedMode && (i === 4 || (i === list.length - 1 && i < 4))) g.append(ask()); });
      const more = $("#more"); more.hidden = list.length <= shown; more.textContent = `Show more (${fmt(list.length - Math.min(shown, list.length))} left)`;
      pills(); $$("[data-need]").forEach(b => b.setAttribute("aria-pressed", b.dataset.need === st.need));
    }
    if (savedMode) document.addEventListener("ahm:saved", () => update(true));
    loadFeed(stock.dataset.feed).then(cars => {
      CARS = cars; document.documentElement.setAttribute("data-js-ready", "");
      $$("[data-total]").forEach(e => (e.textContent = fmt(cars.length)));
      opt($("#f-make"), tally(cars, "make").map(x => x[0]).sort().map(m => [m, m]));
      const years = [...new Set(cars.map(c => c.year).filter(Boolean))].sort((a, b) => b - a).map(y => [y, y]);
      opt($("#f-ymin"), years); opt($("#f-ymax"), years);
      checks("#f-loc", "loc", tally(cars, "loc")); checks("#f-body", "body", tally(cars, "body")); checks("#f-fuel", "fuel", tally(cars, "fuel"));
      checks("#f-trans", "trans", tally(cars, "trans")); checks("#f-drive", "drive", tally(cars, "drive"));
      if (!cars.some(c => c.status === "way") && !st.status) $("#f-avail").closest(".fg").hidden = true;
      needCounts(cars); syncControls(); update();
      if (focusSearch) $("#q").focus();
    }).catch(() => { $("#grid").insertAdjacentHTML("afterbegin", '<div class="empty">Filters couldn\'t load. Refresh the page to try again.</div>'); });

    let qt; $("#q").addEventListener("input", e => { clearTimeout(qt); qt = setTimeout(() => { st.q = e.target.value.trim(); update(); }, 180); });
    $$("#f-avail button").forEach(b => b.addEventListener("click", () => { st.status = b.dataset.v; syncControls(); update(); }));
    $("#f-make").addEventListener("change", e => { st.make = e.target.value; st.model = ""; fillModels(); update(); });
    $("#f-model").addEventListener("change", e => { st.model = e.target.value; update(); });
    ["ymin", "ymax", "km"].forEach(k => $("#f-" + k).addEventListener("change", e => { st[k] = e.target.value; update(); }));
    $("#sort").addEventListener("change", e => { st.sort = e.target.value; update(); });
    $("#more").addEventListener("click", () => { shown += PAGE; update(true); });
    $$("[data-need]", stock).forEach(b => b.addEventListener("click", () => { st.need = st.need === b.dataset.need ? "" : b.dataset.need; update(); }));
    $$("[data-clear]").forEach(b => b.addEventListener("click", () => { const s = st.sort; Object.assign(st, blank()); st.sort = s; syncControls(); update(); }));
    const openF = () => { $("#filters").classList.add("open"); document.body.style.overflow = "hidden"; $("#f-close").focus(); };
    const closeF = () => { $("#filters").classList.remove("open"); document.body.style.overflow = ""; };
    $("#f-open").addEventListener("click", openF);
    $("#f-close").addEventListener("click", closeF);
    $("#f-apply").addEventListener("click", () => { closeF(); stock.scrollIntoView(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeF(); });
  }

  /* ================= CAR PAGE ================= */
  const carEl = $("[data-car]");
  if (carEl) {
    const d = carEl.dataset;
    // gallery
    const track = $("[data-track]"), imgs = track ? $$("img", track) : [];
    if (track && imgs.length > 1) {
      const count = $("[data-count]"), prev = $("[data-prev]"), next = $("[data-next]"), thumbs = $$("[data-thumbs] button");
      const idx = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = i => track.scrollTo({ left: Math.max(0, Math.min(imgs.length - 1, i)) * track.clientWidth, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      const paint = () => {
        const i = idx(); count.textContent = `${i + 1} / ${imgs.length}`;
        prev.disabled = i === 0; next.disabled = i === imgs.length - 1;
        thumbs.forEach((t, j) => t.setAttribute("aria-current", j === i));
        thumbs[i]?.scrollIntoView({ block: "nearest", inline: "nearest" });
      };
      let st2; track.addEventListener("scroll", () => { clearTimeout(st2); st2 = setTimeout(paint, 60); });
      prev.addEventListener("click", () => go(idx() - 1)); next.addEventListener("click", () => go(idx() + 1));
      thumbs.forEach(t => t.addEventListener("click", () => go(+t.dataset.i)));
      track.addEventListener("keydown", e => { if (e.key === "ArrowRight") go(idx() + 1); if (e.key === "ArrowLeft") go(idx() - 1); });
    }
    // enquiry message
    const qs = $$("#qs button");
    const where = d.way === "true" ? "arriving" : d.loc ? `${d.loc} showroom` : "";
    const waUpdate = () => {
      const name = $("#e-name").value.trim(), extra = $("#e-msg").value.trim();
      const lines = [`Hello AHIHQ Motors${name ? ", this is " + name : ""}.`, `I'm interested in the ${d.name} (Ref ${d.ref}${where ? ", " + where : ""}).`];
      qs.filter(b => b.getAttribute("aria-pressed") === "true").forEach(b => lines.push("• " + b.textContent));
      if (extra) lines.push(extra);
      lines.push(location.origin + d.url);
      $("#wa").href = waLink(lines.join("\n"));
    };
    qs.forEach(b => b.addEventListener("click", () => { b.setAttribute("aria-pressed", b.getAttribute("aria-pressed") !== "true"); waUpdate(); }));
    ["#e-name", "#e-msg"].forEach(id => $(id).addEventListener("input", waUpdate));
    $("#eform").addEventListener("submit", e => e.preventDefault());
    waUpdate();
    $("[data-mbar-enq]")?.addEventListener("click", e => { e.preventDefault(); $("#enquire").scrollIntoView({ block: "start" }); $("#e-name").focus({ preventScroll: true }); });
    $("[data-copy]")?.addEventListener("click", async () => {
      const link = location.origin + d.url;
      try { await navigator.clipboard.writeText(link); toast("Link copied. Paste it into WhatsApp"); }
      catch (e) { toast("Copy the link from your browser's address bar"); }
    });
    // similar: same make first, then same body, closest year
    loadFeed().then(cars => {
      const sim = cars.filter(x => x.ref !== d.ref && x.status === "in" && (x.make === d.make || x.body === d.body) && (!isSpecial(x) || x.body === d.body))
        .sort((a, b) => (b.model === d.model) - (a.model === d.model) || (b.make === d.make) - (a.make === d.make) || Math.abs(a.year - d.year) - Math.abs(b.year - d.year))
        .slice(0, 4);
      if (sim.length) { fill($("#similar"), sim); $("[data-similar-wrap]").hidden = false; }
    }).catch(() => {});
  }

  /* ================= SOLD (404 on a car link) ================= */
  const gone = $("[data-gone]");
  if (gone) {
    // handle looks like 2023-toyota-land-cruiser-06801: use its words to find look-alikes
    const words = (gone.dataset.handle || "").toLowerCase().split("-").filter(w => w && !/^\d+$/.test(w));
    loadFeed().then(cars => {
      const score = c => words.filter(w => c._s.includes(w)).length;
      const list = cars.filter(c => c.status === "in" && !isSpecial(c) && c.img).sort((a, b) => score(b) - score(a) || b.year - a.year).slice(0, 4);
      fill($("#gone-list"), list);
    }).catch(() => { $("#gone-list").innerHTML = ""; });
  }

  /* ================= WHATSAPP FORMS (contact, find me a car) ================= */
  $$("[data-wa-form]").forEach(form => {
    const kind = form.dataset.waForm, err = $("[data-err]", form);
    if (kind === "request") {
      const y = $("#r-year"); const now = new Date().getFullYear();
      for (let i = now; i >= now - 15; i--) opt(y, [[i, `${i} or newer`]]);
      loadFeed().then(cars => opt($("#r-makes"), tally(cars, "make").map(x => [x[0], x[0]]))).catch(() => {});
    }
    form.addEventListener("submit", e => {
      e.preventDefault();
      const v = n => (form.elements[n]?.value || "").trim();
      if (!v("name") || v("phone").replace(/\D/g, "").length < 9) {
        err.textContent = !v("name") ? "Add your name so we know who we're talking to." : "Add a phone number we can reach you on (at least 9 digits).";
        err.hidden = false; (v("name") ? form.elements.phone : form.elements.name).focus(); return;
      }
      err.hidden = true;
      let lines;
      if (kind === "request") {
        lines = ["Hello AHIHQ Motors, please find me a car.", ""];
        const car = [v("make"), v("model")].filter(Boolean).join(" ");
        if (car) lines.push(`Car: ${car}`);
        if (v("need")) lines.push(`For: ${v("need")}`);
        if (v("year")) lines.push(`Year: ${v("year")} or newer`);
        if (v("trans")) lines.push(`Transmission: ${v("trans")}`);
        if (v("budget")) lines.push(`Budget: KES ${v("budget")}`);
        if (v("pay")) lines.push(`Paying by: ${v("pay")}`);
        lines.push(`When: ${v("when")}`);
        if (v("notes")) lines.push(`Notes: ${v("notes")}`);
      } else {
        lines = [`Hello AHIHQ Motors, I'm looking to: ${v("type")}`];
        if (v("car")) lines.push(`Vehicle: ${v("car")}`);
        if (v("msg")) lines.push(v("msg"));
      }
      lines.push("", `Name: ${v("name")}`, `Phone: ${v("phone")}`);
      const url = waLink(lines.join("\n"));
      const a = document.createElement("a"); a.href = url; a.target = "_blank"; a.rel = "noopener";
      document.body.append(a); a.click(); a.remove();
    });
  });

  paintSaved();
})();
